import {
    faClock,
    faLocationDot,
    faUserSecret,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useSelector } from "react-redux";
import { extractOnlyTwoDigitDate } from "../../../../utils/extractOnlyTwoDigitDate";
import { extarctOnlyMonth } from "../../../../utils/extarctOnlyMonth";
import { extarctOnlyDay } from "../../../../utils/extarctOnlyDay";
import { extractIntoDDMMFormat } from "../../../../utils/extractIntoDDMMFormat";
import { formatTimeRange } from "../../../../utils/formattedTimeRange";
import { useNavigate } from "react-router-dom";
import { getDateValueWithSingleTime } from "../../../../utils/getDate";


const AddOnOrderDetailsList = () => {
    const { addOnOrderListToShowById } = useSelector((state) => state.orders)
    const navigate = useNavigate();
    const gotoAddonOrder = (id) => {
        navigate(`/order-details/${id}`)
        window.scrollTo(0, 0);
    }

    return (
        <>
            <div className="upcoming-box-row">

                {addOnOrderListToShowById && addOnOrderListToShowById?.length > 0 && addOnOrderListToShowById?.map((item, idx) => {
                    // console.log(item.offlinePaymentDetails.remark);
                    return (
                        <>

                            <div className="upcoming-box-col pointer" key={idx + 1} onClick={() => gotoAddonOrder(item?._id)}>
                                <div className="upcoming-date-time-wrap">
                                    <div className="upcoming-date">{extractOnlyTwoDigitDate(item?.createdAt)}</div>
                                    <div className="upcoming-month">{extarctOnlyMonth(item?.createdAt)}</div>
                                    <div className="upcoming-day"> {extarctOnlyDay(item?.createdAt)}</div>
                                </div>

                                <div className="upcoming-box-right">
                                    <div className="upcoming-heading-wrap">
                                        <div className="upcoming-heading">
                                            <h5>
                                                {`Extra ${item?.addOnOrderDetails?.hour} hours of cleaning with
            ${item?.addOnOrderDetails?.noOfStaff} Cleaners`}
                                                {/* <span className="up-count">{extractIntoDDMMFormat(item?.createdAt)}</span> */}
                                            </h5>
                                        </div>
                                        <div className="upcm-add">
                                            <div className="upcm-add-details">
                                                <ul className="list-unstyled">
                                                    <li>
                                                        <FontAwesomeIcon icon={faLocationDot} />
                                                        {item?.address?.formatedAddress}
                                                    </li>
                                                </ul>
                                            </div>
                                            <ul className="list-unstyled">
                                                <li>
                                                    <FontAwesomeIcon icon={faClock} />
                                                    {formatTimeRange(item?.svcStartDate, item?.svcEndDate)}
                                                </li>
                                            </ul>
                                            {item?.status === "Paid" &&
                                                <>
                                                    <hr />
                                                    <ul className="addonClass">
                                                        <li>
                                                            <span>Payment mode:  </span>
                                                            {item?.paymentDetails ?
                                                                item?.paymentDetails.paymentType :
                                                                "other mode"
                                                            }
                                                        </li>
                                                        <li>
                                                            <span>Remark:  </span>
                                                            {item?.paymentDetails?.offlinePaymentDetails ?
                                                                item?.paymentDetails?.offlinePaymentDetails.remark : " "}
                                                        </li>
                                                        <li>
                                                            <span> Payment date:  </span>
                                                            {item?.paymentDetails?.offlinePaymentDetails ?
                                                                getDateValueWithSingleTime(item.paymentDetails.offlinePaymentDetails.Date) : " "}
                                                        </li>
                                                        <li>
                                                            <span> Transaction Id:  </span>
                                                            {item?.paymentDetails?.offlinePaymentDetails ?
                                                                item?.paymentDetails?.offlinePaymentDetails.transactionId : " "}
                                                        </li>
                                                    </ul>
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                                {item?.status && item?.status == "Upcoming" ? (
                                    <div className="up-green">
                                        <p className="mb-0"> {item?.status}</p>
                                    </div>
                                ) : (
                                    <div className={item?.status === 'Paid' ? `up-green` : `up-green up-yellow`}>
                                        <p className="mb-0"> {item?.status}</p>
                                    </div>
                                )}
                            </div>
                        </>
                    )
                })}
            </div>
        </>
    );
};

export default AddOnOrderDetailsList;
